export const COUNTER_PILL_WIDTH = 150;
export const COUNTER_PILL_HEIGHT = 32;
export const COUNTER_PILL_PADDING = 6;
export const COUNTER_PILL_RADIUS_CSS = "8px";
export const COUNTER_ARROW_SIZE = 26;
export const COUNTER_ARROW_FONT_SIZE = 16;
export const COUNTER_FONT_SIZE = 14;
